'use strict';

var _classCallCheck = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var assert = require('assert');
var RedisError = /*#__PURE__*/function (_Error) {
  _inherits(RedisError, _Error);
  function RedisError() {
    _classCallCheck(this, RedisError);
    return _possibleConstructorReturn(this, _getPrototypeOf(RedisError).apply(this, arguments));
  }
  _createClass(RedisError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);
  return RedisError;
}(_wrapNativeSuper(Error));
var ParserError = /*#__PURE__*/function (_RedisError) {
  _inherits(ParserError, _RedisError);
  function ParserError(message, buffer, offset) {
    var _this;
    _classCallCheck(this, ParserError);
    assert(buffer);
    assert.strictEqual(typeof offset, 'number');
    var tmp = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParserError).call(this, message));
    Error.stackTraceLimit = tmp;
    _this.offset = offset;
    _this.buffer = buffer;
    return _this;
  }
  _createClass(ParserError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);
  return ParserError;
}(RedisError);
var ReplyError = /*#__PURE__*/function (_RedisError2) {
  _inherits(ReplyError, _RedisError2);
  function ReplyError(message) {
    var _this2;
    _classCallCheck(this, ReplyError);
    var tmp = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReplyError).call(this, message));
    Error.stackTraceLimit = tmp;
    return _this2;
  }
  _createClass(ReplyError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);
  return ReplyError;
}(RedisError);
var AbortError = /*#__PURE__*/function (_RedisError3) {
  _inherits(AbortError, _RedisError3);
  function AbortError() {
    _classCallCheck(this, AbortError);
    return _possibleConstructorReturn(this, _getPrototypeOf(AbortError).apply(this, arguments));
  }
  _createClass(AbortError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);
  return AbortError;
}(RedisError);
var InterruptError = /*#__PURE__*/function (_AbortError) {
  _inherits(InterruptError, _AbortError);
  function InterruptError() {
    _classCallCheck(this, InterruptError);
    return _possibleConstructorReturn(this, _getPrototypeOf(InterruptError).apply(this, arguments));
  }
  _createClass(InterruptError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);
  return InterruptError;
}(AbortError);
module.exports = {
  RedisError: RedisError,
  ParserError: ParserError,
  ReplyError: ReplyError,
  AbortError: AbortError,
  InterruptError: InterruptError
};